export default __webpack_public_path__ + "static/media/beeLogo.e0b0ed72.png";